import { render, staticRenderFns } from "./extra-info.vue?vue&type=template&id=7091ed1c&"
import script from "./extra-info.vue?vue&type=script&lang=js&"
export * from "./extra-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports